import {ValueAndLabelModel} from '../../../../../../common/model/valueAndLabel.model';

export class InsolesTypeFamilySummaryModel extends ValueAndLabelModel{
    rank: number;
}
